export function Svg(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props} />;
}
